import {registerComponent} from '@helpers/vue'
// import CreateOSBTask from 'src/vue/areas/data-transfer/osb/CreateTask'
// registerComponent(CreateOSBTask, 'data-transfer/osb/create-task')

import CreateOSBTask from 'src/vue/areas/data-transfer/osb/CreateTask'
registerComponent(CreateOSBTask, 'data-transfer/osb/create-task', {el: '#osb-button-container'})
